import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CellularDeviceActivationService } from '@caslink/common-client/ng-app/cellular-device-activation/cellular-device-activation.service';

@Component({
    selector: 'cl-cellular-device-status',
    templateUrl: './cellular-device-status.component.html'
})
export class CellularDeviceStatusComponent{
    static $name: string = 'clCellularDeviceStatus';

    @Input() moduleId: number;
    @Output() onCellularDeviceStatusChange = new EventEmitter<CASLink.Device.Ui.ViewModel.Modules.CellularDeviceStatusViewModel>();

    constructor(
        private cellularDeviceActivationService: CellularDeviceActivationService
    ) {
    }

    sendStatusUpdateRequest() {
        this.cellularDeviceActivationService.updateCellularDeviceStatus(this.moduleId).then(
            response => {
                this.onCellularDeviceStatusChange.emit({...response});
            });
    }
}
